var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "384px",
    viewBox: "0 0 512 384",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "611422d38125d221bba64d06_checked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "611422d38125d221bba64d06_checked",
    transform: "translate(0.000000, -0.001490)",
    fill: "#19C27F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 208.336041 175.33127 384.001986 512 47.6659451 463.665697 1.41128367e-14 175.33127 287.999752 47.664952 160.334427"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenChecked);
export default __webpack_public_path__ + "static/media/green_checked.f70ad86f48035841f5a57ebe5ce93504.svg";
export { ForwardRef as ReactComponent };